export default {
  webRoot: {
    //默认服务名
    policy: "/policy/",
    iagent: "/ias/"
  },
}